import { Injectable } from '@angular/core'; import { from, of } from 'rxjs'; import { Capacitor } from '@capacitor/core';
import { switchMap, map, catchError } from 'rxjs/operators'; import { AuthService } from 'src/app/services/auth.service';
import { LocalstorageService } from 'src/app/services/localstorage.service'; import { lastValueFrom } from 'rxjs'; import { IUserData } from 'src/app/@types/UserData';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router'; import { HttpClient } from '@angular/common/http';
import { LayoutService } from 'src/app/layout/service/app.layout.service'; import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { Observable } from 'rxjs'; import { environment } from 'src/environments/environment'; import { firstValueFrom } from 'rxjs';
export interface Stores {
	store_id: number;
	store_name: string;
	store_domain: string;
}
@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(
		private router: Router,
		private http: HttpClient,
		private localstorageService: LocalstorageService,
		private authService: AuthService,
		private authHeaderService: AuthHeaderService,
		public layoutService: LayoutService) {
	  console.log('[Capacitor] referenced in AuthGuard');
	  }

	async canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {

		const accessToken = localStorage.getItem('access_token');
		const userId = this.authService.getLoggedUserId();
		const isNative = Capacitor.isNativePlatform();

		if (isNative) {
			// Nativo (Capacitor): EXIGE access_token
			if (!accessToken) {
				// limpeza defensiva em caso de lixo remanescente
				localStorage.removeItem('user_id');
				this.authService.clearUser();
				return this.router.parseUrl('/auth/login');
			}

			// Se tem token, valida expiração
			const tokenData = this.decodeJwtToken(accessToken);
			const now = Date.now() / 1000;
			if (tokenData.exp && now >= tokenData.exp) {
				localStorage.clear();
				this.authService.clearUser();
				return this.router.parseUrl('/auth/login');
			}

			// OK nativo
			return true;
		}


		// 2. Caso Web (Laravel Sanctum via Cookie)
		if (userId) return true;

		return this.router.parseUrl('/auth/login');
	}


	decodeJwtToken(token: string): any {
		// Decodificar o token JWT para obter os dados
		let base64Url = token.split('.')[1];
		let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		let jsonPayload = decodeURIComponent(atob(base64).split('').map((c: string) => {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));

		return JSON.parse(jsonPayload);
	}
}

